import React, { FC, useCallback, useState } from 'react'
import { useFormContext, useWatch } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { Link as RouterLink } from 'react-router-dom'

import { LoadingButton } from '@mui/lab'
import { Link, Stack, Typography } from '@mui/material'
import { TextHookField } from '@procom-labs/molecules'

import { ValidateSignInFormValues } from '@auth-portal/types'

import { CommonEndAdornment } from './common-end-adornment'

export const PasswordValidateScreen: FC<{
  isLoading: boolean
}> = ({ isLoading }) => {
  const { t } = useTranslation('main')
  const [showPassword, setShowPassword] = useState(false)

  const { control } = useFormContext<ValidateSignInFormValues>()

  const email = useWatch({ control, name: 'email' })

  const handleShowPassword = useCallback(() => {
    setShowPassword((prev) => !prev)
  }, [])

  return (
    <Stack direction="column" rowGap={2} marginX={4} mt={2}>
      <TextHookField
        control={control}
        name="email"
        label={t('form.email.label')}
        required
        disabled
        defaultValue={email}
        customLabel={false}
      />

      <TextHookField
        control={control}
        name="password"
        required
        label={t('form.login.password.label')}
        type={showPassword ? 'text' : 'password'}
        customLabel={false}
        InputLabelProps={{
          shrink: false,
        }}
        InputProps={{
          endAdornment: (
            <CommonEndAdornment
              showPassword={showPassword}
              handleShowPassword={handleShowPassword}
            />
          ),
        }}
      />

      <Stack direction="row" justifyContent="flex-end" alignItems="center">
        <Link
          component={RouterLink}
          underline="none"
          to={`/reset-password?email=${email}`}
          id="btn-forgot-password"
        >
          <Typography
            component="span"
            variant="body1Bold700"
            sx={{
              lineHeight: 1.5,
            }}
          >
            {t('form.login.forgotPassword')}
          </Typography>
        </Link>
      </Stack>

      <LoadingButton
        size="large"
        type="submit"
        color="secondary"
        variant="contained"
        fullWidth
        loading={isLoading}
      >
        {t('common.btn.submit')}
      </LoadingButton>
    </Stack>
  )
}
